import FlatpickrYearDropdownPlugin from "./../../Scalesoft.Shared.FrontEnd/Scripts/FlatpickrYearDropdownPlugin";
import Utils from "./../../Scalesoft.Shared.FrontEnd/Scripts/Utils";

declare const flatpickr: any;

jq(() => {
    const datePicker = new DatePicker(
        window.localization,
    );
    datePicker.init();
});

export default class DatePicker {
    private readonly culture: string;
    private readonly mLocalization: Localization;
    private readonly utils: Utils;

    constructor(
        localization: Localization,
    ) {
        this.mLocalization = localization;
        this.utils = new Utils();
        this.culture = this.utils.getCurrentLanguage(this.mLocalization);
    }

    public init(): void {
        this.initDatePickers();
    }

    private initDatePickers(): void {
        jq(`input[type="date"]`).each((i, inputElement: HTMLInputElement) => {
            this.initDatePickerInput(inputElement);
        });
    }

    private parseDate(value: string, format: string): Date {
        const splittedFormat = format.toLowerCase().split(/[,-.]/);
        const splittedDate = value.split(/[,-.]/);
        const month = parseInt(splittedDate[splittedFormat.indexOf("m")], 10) - 1; // months are indexed from 0 to 11
        const year = parseInt(splittedDate[splittedFormat.indexOf("y")], 10);
        const day = parseInt(splittedDate[splittedFormat.indexOf("d")], 10);
        if (day > 31 || month > 11) {
            return new Date("invalid");
        }
        return new Date(year, month, day);
    }

    public initDatePickerInput(dateInput: HTMLInputElement): void {
        const element = jq(dateInput);

        let minDate: string;
        let maxDate: string;

        let minYear: string;
        let maxYear: string;
        let yearRange: string;

        if (element.attr("min")) {
            minDate = element.attr("min");
        }

        if (element.attr("max")) {
            maxDate = element.attr("max");
        }

        if (minDate) {
            minYear = minDate.substr(0, 4);
        }

        if (maxDate) {
            maxYear = maxDate.substr(0, 4);
        }

        if (typeof minYear !== "undefined" &&
            minYear != null &&
            typeof maxYear !== "undefined" &&
            maxYear != null) {
            yearRange = minYear + ":" + maxYear;
        }

        const locale = this.culture;

        const getYearDropdownSelect = new FlatpickrYearDropdownPlugin().init();

        const altFormat = jq("#constants").data("flatpicker-date") as string;
        const defaultDate = dateInput.value;
        const flatpickrInstance = flatpickr(dateInput,
            {
                plugins: [
                    getYearDropdownSelect({}),
                ],
                locale,
                dateFormat: "Y-m-d",
                disableMobile: "true",
                defaultDate,
                enableTime: false,
                minDate,
                maxDate,
                altInput: true,
                allowInput: true,
                altFormat,
                onChange: () => {
                    flatpickrInstance.close();
                },
                onReady: (selectedDates, dateStr, instance) => {
                    if (instance.isMobile) {
                        // WORKAROUND removing step attribute, otherwise validation crashes. Details in IN2-3150
                        jq(instance.mobileInput).removeAttr("step");
                    }
                },
            });
        element.addClass("flatpickr-input");

        const setDateHandler = (event) => {
            const value = jq(event.currentTarget).val() as string;
            const date = flatpickrInstance.isMobile ? new Date(value) : this.parseDate(value, altFormat);
            flatpickrInstance.changeYear(date.getFullYear());
            flatpickrInstance.changeMonth(date.getMonth(), false);
            flatpickrInstance.setDate(date, true);
        };

        element.next("input:visible")
            .on("change", setDateHandler)
            .on("keydown", (event) => {
                if (event.key === "Enter") {
                    setDateHandler(event);
                }
            });

    }
}
